import React, { useMemo } from 'react';
import type { TabItem } from '@splunk/dashboard-types';
import { _ } from '@splunk/ui-utils/i18n';
import { sprintf } from '@splunk/ui-utils/format';
import { useSelector, selectActiveTab } from '@splunk/dashboard-state';
import {
    Row,
    StyledWaitSpinner,
    TextContainer,
    CompletionText,
} from './SearchProgress';

export interface TabDownloadProgressArgType {
    tabs: TabItem[];
    layoutIds: string[];
}

const SEARCH_PROGRESS_TEXT = _(
    'Downloading tab %(currentTabNumber)d of %(totalTabs)d'
);

export const TabDownloadProgress = ({
    tabs,
    layoutIds,
}: TabDownloadProgressArgType) => {
    const activeTab = useSelector(selectActiveTab);

    const tabIds = useMemo(() => tabs.map((tab) => tab.layoutId), [tabs]);

    const sortedLayoutIds = useMemo(
        () => tabIds.filter((tabId) => layoutIds.includes(tabId)),
        [layoutIds, tabIds]
    );

    const currentTabNumber = useMemo(() => {
        if (typeof activeTab === 'undefined') {
            return -1;
        }

        return sortedLayoutIds.indexOf(activeTab) + 1;
    }, [activeTab, sortedLayoutIds]);

    const totalTabs = sortedLayoutIds.length;

    const TabDownloadProgressText = sprintf(SEARCH_PROGRESS_TEXT, {
        currentTabNumber,
        totalTabs,
    });

    return (
        <Row>
            <StyledWaitSpinner />
            <TextContainer>
                <CompletionText>{TabDownloadProgressText}</CompletionText>
            </TextContainer>
        </Row>
    );
};
